import { render, staticRenderFns } from "./Danfe.vue?vue&type=template&id=899bdc66&scoped=true"
import script from "./Danfe.vue?vue&type=script&lang=js"
export * from "./Danfe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899bdc66",
  null
  
)

export default component.exports